<template>
  <!-- Header Contents - Secondary background -->
  <header>
    <div class="text-right font-weight-bold p-1 mt-4 mb-2 user-icon" v-show="this.user_info.name">
      <img class="user-img"
        :src="this.user_info.image_url"/>
      <div>
        {{this.user_info.name}}さん
      </div>
      <div v-show="false">
        <a href="#" @click="logout()">ログアウト</a>
      </div>
    </div>
    <div class="row background-secondary">
      <!-- Header -->
      <div class="col-6 p-0 mt-4 mb-2 mx-auto">
        <img
          src="@/assets/img/campaign/header.png"
          alt="Header"
          class="img-fluid mx-auto d-block"
        />
      </div>
    </div>

    <div
      class="row background-secondary"
      style="
        padding-bottom: 20vh;
        border-bottom-left-radius: 25%;
        border-bottom-right-radius: 25%;
      "
    ></div>
  </header>
</template>

<script>
import {getUserInfo} from '@/utils/auth';

export default {
  data() {
    return {
      user_info: {
        name: "",
        image_url: ""
      }
    }
  },
  created() {
    if (getUserInfo()) {
      this.user_info = getUserInfo()
    }
  },
  
  mounted() {
    if (this.$route.path == "/logout") {
      this.resetUserInfo()
    }
  },

  methods: {
    logout() {
      this.resetUserInfo()

      this.$router.push("/logout");
    },

    resetUserInfo() {
      this.user_info = {
        name: "",
        image_url: ""
      }
    }
  }
}
</script>

<style>
.header-user {
  padding: 20px 20px;
  font-weight: bold;
}

.user-icon{
  font-size: 10px;
  position: absolute;
  right: 0;
}

.user-img {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    margin: 0px 0px 5px 0px;
}
</style>
